export default "__VITE_ASSET__B8k5JYXT__"